import { Component, EventEmitter, Input, Output } from "@angular/core";
import { NonAddedSalesOrderLineDto } from "../../../core/models/project-workflow/getNonAddedProjectWorkflowLineDto";
import { CommonModule } from "@angular/common";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { InputTextModule } from "primeng/inputtext";
import {
  TableModule,
  TableRowSelectEvent,
  TableRowUnSelectEvent,
} from "primeng/table";

@Component({
  selector: "jni-add-workflow-lines",
  templateUrl: "./add-workflow-lines.component.html",
  styleUrls: ["./add-workflow-lines.component.scss"],
  imports: [
    CommonModule,
    TableModule,
    ButtonModule,
    CardModule,
    InputTextModule,
  ],
})
export class AddWorkflowLinesComponent {
  @Input() nonAddedLines = [] as NonAddedSalesOrderLineDto[];
  @Output() postLineRecIdListEvent = new EventEmitter<number[]>();
  @Output() closeModalEvent = new EventEmitter();
  addButtonEnabled = false;
  lineRecIdList = [] as number[];
  selectedLines: NonAddedSalesOrderLineDto[] = [];

  handleRowSelect(event: TableRowSelectEvent) {
    if (!Array.isArray(event.data)) {
      this.lineRecIdList.push(event.data ?? 0);
      this.addButtonEnabled = true;
    }
  }

  handleRowUnselect(event: TableRowUnSelectEvent<NonAddedSalesOrderLineDto>) {
    if (!Array.isArray(event.data)) {
      const lineRecId = event.data ?? 0;
      this.lineRecIdList = this.lineRecIdList.filter(el => el !== lineRecId);
      if (this.lineRecIdList.length <= 0) {
        this.addButtonEnabled = false;
      }
    }
  }

  closeModalDialog() {
    this.closeModalEvent.emit();
  }

  addLinesToProject() {
    this.postLineRecIdListEvent.emit(this.lineRecIdList);
  }
}
